import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import LinearProgress from "@material-ui/core/LinearProgress";
import { ResultAssessments } from "../../components";
import {
  asyncGetParticipantAssessmentResult,
  redirectToParticipant,
} from "../../actions/assessmentActions";

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: "50px 0 0 0.3px",
  },
  buttonWrapper: {
    marginTop: 50,
  },
  root: {
    flexGrow: 1,
  },
}));

export const ResultAssesments = () => {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { request, participantAssessmentResult, disableButtonSetPassword } =
    useSelector((state) => ({
      request: state.request.request,
      participantAssessmentResult:
        state.initialAssessment.initialAssessment.participantAssessmentResult,
      disableButtonSetPassword:
        state.initialAssessment.initialAssessment.disableButtonSetPassword,
    }));

  useEffect(() => {
    dispatch(asyncGetParticipantAssessmentResult(id));
  }, [dispatch, id]);

  const setPassword = () => {
    redirectToParticipant(`/new-password?id=${id}`);
  };

  return (
    <Container className={classes.wrapper}>
      <Grid container className={classes.root} spacing={8}>
        <Grid item>
          <Typography component="h1" variant="h3">
            Financial Education Assessment Score
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            BUILD GREAT HABITS <br />
            The first part of your financial journey begins with having good
            financial habits. In this section you can see where all of your
            money is going as well as other spending habits.
          </Typography>
        </Grid>
      </Grid>

      {request.isFetching && <LinearProgress color="secondary" />}
      <Grid container className={classes.root} spacing={2}>
        <ResultAssessments assessmentResult={participantAssessmentResult} />
      </Grid>
      <Grid
        container
        className={classes.buttonWrapper}
        justify="center"
        alignItems="center"
      >
        <Grid item>
          <Button
            onClick={() => setPassword()}
            color="primary"
            variant="contained"
            disabled={!disableButtonSetPassword}
          >
            Set Password
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
